import { IBaseStateModel } from '../../models/StateModels';
import { IAction } from '../../models/ActionModels';

const api_set_input_state = <
  TValue,
  TState extends IBaseStateModel,
  TAction extends IAction<TValue>
>(
  state: TState,
  action: TAction
): TState => {
  return {
    ...state,
    InProgress: false,
    Input: action.payload && 'input' in action.payload ? action.payload?.input : null,
  };
};

const api_reset_store = <TState extends IBaseStateModel, TAction extends IAction<TState>>(
  state: TState,
  action: TAction
): TState => {
  return {
    ...((action.payload && 'input' in action.payload ? action.payload?.input : state) || state),
  };
};

const api_async_complete_state = <
  TValue,
  TState extends IBaseStateModel,
  TAction extends IAction<TValue>
>(
  state: TState,
  action: TAction
): TState => {
  return {
    ...state,
    InProgress: false,
    Data: action.payload && 'data' in action.payload ? action.payload.data : null,
    Error:
      action.payload && 'hasError' in action.payload && action.payload?.hasError
        ? action.payload.error
        : null,
  };
};

const api_async_start_state = <
  TValue,
  TState extends IBaseStateModel,
  TAction extends IAction<TValue>
>(
  state: TState,
  action: TAction
): TState => {
  return {
    ...state,
    Input: action.payload && 'input' in action.payload ? action.payload?.input : null,
    InProgress: true,
  };
};

const api_page_loaded_state = <
  TValue,
  TState extends IBaseStateModel,
  TAction extends IAction<TValue>
>(
  state: TState,
  action: IAction<any>
): TState => {
  return {
    ...state,
    Input: null,
    Initiated: true,
  };
};

const api_page_unloaded_state = <
  TValue,
  TState extends IBaseStateModel,
  TAction extends IAction<TValue>
>(
  state: TState,
  action: IAction<any>
): TState => {
  return {
    ...state,
    Input: null,
    Initiated: false,
  };
};

const page_loaded_state = <TValue, TState extends IBaseStateModel, TAction extends IAction<TValue>>(
  state: TState,
  action: TAction
): TState => {
  return {
    ...state,
    Initiated: true,
  };
};

const page_unloaded_state = <
  TValue,
  TState extends IBaseStateModel,
  TAction extends IAction<TValue>
>(
  state: TState,
  action: TAction
): TState => {
  return {
    ...state,
    Initiated: false,
  };
};

const page_props_sent = <TValue, TState extends IBaseStateModel, TAction extends IAction<TValue>>(
  state: TState,
  action: TAction
): TState => {
  return {
    ...state,
    Obj: action.payload && 'props' in action.payload ? action.payload.props : {},
  };
};

export default {
  api_set_input_state: api_set_input_state,
  api_reset_store: api_reset_store,
  api_async_complete_state: api_async_complete_state,
  api_async_start_state: api_async_start_state,
  api_page_unloaded_state: api_page_unloaded_state,
  api_page_loaded_state: api_page_loaded_state,
  page_unloaded_state: page_unloaded_state,
  page_loaded_state: page_loaded_state,
  page_props_sent: page_props_sent,
};
